import React from "react";

import { useTranslation } from "react-i18next";

import { Badge } from "@/src/components/ui/badge";
import { cn } from "@/src/lib/utils";

import type { VariantProps } from "class-variance-authority";
import type { JSX } from "react";

import type { StorageTestStatus } from "@/src/api/ProjectAPI.types";
import type { badgeVariants } from "@/src/components/ui/badge";

type BadgeVariant = VariantProps<typeof badgeVariants>["variant"];

const CONFIG: Record<
  StorageTestStatus,
  { variant: BadgeVariant; dotClassName: string; labelKey: string }
> = {
  success: {
    variant: "success",
    dotClassName: "bg-status-active",
    labelKey: "storageAccess.status.success",
  },
  failed: {
    variant: "error",
    dotClassName: "bg-status-error",
    labelKey: "storageAccess.status.failed",
  },
  untested: {
    variant: "neutral",
    dotClassName: "bg-status-neutral",
    labelKey: "storageAccess.status.untested",
  },
};

interface StatusPillProps {
  status: StorageTestStatus;
}

export default function StatusPill({ status }: StatusPillProps): JSX.Element {
  const { t } = useTranslation("editor-organization");
  const config = CONFIG[status];

  return (
    <Badge className="gap-1.5" variant={config.variant}>
      <span className={cn("size-1.5 rounded-full", config.dotClassName)} />
      {t(config.labelKey)}
    </Badge>
  );
}
